// Dona reutilizable con grosor controlable (Tremor 3.18 fija el innerRadius al 75%,
// por eso usamos recharts directamente para poder engrosarla y mantener el mismo
// grosor en todas las tortas del tablero).
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

export interface ThickDonutDatum {
  name: string;
  value: number;
}

interface ThickDonutProps {
  data: ThickDonutDatum[];
  colors: string[];
  centerLabel?: string;
  centerSub?: string;
  height?: number;
  /** Radio interior en % del contenedor. Menor = dona más gruesa. */
  innerRadius?: number;
  outerRadius?: number;
}

export default function ThickDonut({
  data,
  colors,
  centerLabel,
  centerSub,
  height = 150,
  innerRadius = 55,
  outerRadius = 100,
}: ThickDonutProps) {
  return (
    <div className="relative" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={`${innerRadius}%`}
            outerRadius={`${outerRadius}%`}
            paddingAngle={1}
            stroke="none"
            isAnimationActive={false}
          >
            {data.map((_, i) => (
              <Cell key={i} fill={colors[i % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      {centerLabel && (
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-sm font-bold text-tremor-content-emphasis tabular-num">
            {centerLabel}
          </span>
          {centerSub && (
            <span className="text-[10px] text-tremor-content">{centerSub}</span>
          )}
        </div>
      )}
    </div>
  );
}
